module.exports = {"410323100":"城关镇","410323101":"石寺镇","410323102":"五头镇","410323103":"磁涧镇","410323104":"铁门镇","410323105":"南李村镇","410323106":"北冶镇","410323107":"仓头镇","410323108":"正村镇","410323109":"石井镇","410323205":"曹村乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410323.json
// module id = 1418
// module chunks = 0